export const FETCH_VENUES = 'FETCH_VENUES'
export const DISABLE_VENUE = 'DISABLE_VENUE'
export const GET_VENUE_SLUG = 'GET_VENUE_SLUG'
